/*
 * @Description: 
 * @Author: 陈长吉
 * @Date: 2018-10-29 16:31:16
 * @LastEditTime: 2019-10-15 10:10:06
 * @LastEditors: Please set LastEditors
 */
/* eslint-disable */
import { 
  Observable,
  of
} from 'rxjs'
import {
  catchError,
  tap,
  map
} from 'rxjs/operators'

window.cacheData = {}
let clearTime = new Date().getTime()

/**
 * HTTP 数据代理
 *
 * @export
 * @param {*} httpStream - GET/POST等Observable请求流
 * @param {*} filterResponse - response 过滤器
 * @param {*} sideEffect - 副作用函数 （state: start | ajaxError | filterError | complete, response）
 * @returns
 */
export function httpAgent(httpStream, filterResponse, sideEffect, options) {
  sideEffect = sideEffect || function () {}
  filterResponse = filterResponse || function (res) {
    if (!res.response) {
      throw new Error(res.responseText)
    }
    return res
  }
  // 写入副作用状态
  sideEffect('start', {
    options
  })
  // 获取缓存数据
  const cache = hasCache(httpStream, options)
  // 存在缓存
  if (cache) {
    sideEffect('complete', {
      cache,
      options
    })
    return new Observable(observer => {
      observer.next({...cache})
    })
  }
  // 没有缓存
  return httpStream.pipe(
    catchError(err => {
      return of({
        status: err.status,
        request: err.request,
        responseText: err.message
      }).pipe(
        tap(errorResponse => sideEffect('ajaxError', {
          error: errorResponse.responseText,
          response: errorResponse,
          options
        }))
      )
    }),
    map(filterResponse),
    catchError(error => {
      return of(error).pipe(
        tap(error => sideEffect('filterError', {
          error,
          options
        }))
      )
    }),
    tap(data => {
      if (data.responseText) {
        throw data
      }
      sideEffect('complete', {
        data,
        options
      })
      setTimeout(() => {
        // 执行接口数据缓存
        setHttpCache(httpStream, options, data)
        // 执行清理过期缓存数据
        clearCache()
      }, 0)
    }))
}

/**
 * HTTP 缓存数据
 *
 * @export
 * @param {*} httpStream - GET/POST等Observable请求流
 * @param {*} filterResponse - response 过滤器
 * @param {*} sideEffect - 副作用函数 （state: start | ajaxError | filterError | complete, response）
 * @returns
 */
export function setHttpCache(httpStream, options, data) {
  const {cache} = options
  if (cache) {
    const url = mixUrl(httpStream)
    window.window.cacheData[url] = {
      data: JSON.stringify(data),
      date: new Date().getTime() + cache * 1000
    }
  }
}

/**
 * HTTP 判断缓存并返回
 *
 * @export
 * @param {*} httpStream - GET/POST等Observable请求流
 * @param {*} options - 参数
 * @returns 缓存数据
 */
export function hasCache(httpStream, options) {
  // 强制刷新不适用缓存
  if (options.refresh) {
    return false
  }
  const { cache } = options
  if (cache) {
    const url = mixUrl(httpStream)
    if (window.cacheData[url] && window.cacheData[url].date > new Date().getTime()) {
      return JSON.parse(window.cacheData[url].data)
    }
  }
  return false
}

/**
 * HTTP 清理过期缓存 固定一个间隔时间清理过期缓存 默认30秒清理一次
 *
 * @export
 * @param {*} interval - 清理缓存数据间隔时间
 * @returns 缓存数据
 */
export function clearCache(interval = 10) {
  const nowDate = new Date().getTime()
  // 判断缓存间隔清理时间
  if (clearTime + interval * 1000 < nowDate) {
    clearTime = nowDate
    Object.keys(window.cacheData).forEach((item) => {
      if (window.cacheData[item].date < nowDate) {
        delete window.cacheData[item]
      }
    })
  }
}

/**
 * HTTP 处理http的缓存用的url
 *
 * @export
 * @param {*} httpStream - 请求参数
 * @returns 处理后的url字符串
 */
export function mixUrl(httpStream) {
  const { method, body } = httpStream.source.request
  let { url } = httpStream.source.request
  if (method === 'POST') {
    if (typeof body === 'object') {
      url = `${url}${JSON.stringify(body)}`
    } else {
      url = `${url}${body}`
    }
  }
  return url
}
